module.exports = __webpack_public_path__ + "static/media/thought_icon.e3061e0c.png";